import { LAYER_REGISTRY } from "../map/layers/registry";
import type { LayerName, MeasureId } from "../map/layers/types";
import { formatBinLabel } from "../map/layers/binning";
import { COPY } from "../content/copy";
import "../styles/legend.css";

type Props = {
  activeLayer: LayerName;
  activeMeasure: MeasureId;
  onMeasureChange: (m: MeasureId) => void;
};

export function LegendStrip({ activeLayer, activeMeasure, onMeasureChange }: Props) {
  const entry = LAYER_REGISTRY[activeLayer];
  const copyBlock = (COPY.layers as any)[activeLayer];
  const hasPicker = entry.measures.length > 1;

  return (
    <div className="legend-strip">
      <div className="legend-title mono">{copyBlock.title.text}</div>
      {hasPicker && (
        <div className="legend-measure-picker" data-testid="legend-measure-picker">
          {entry.measures.map((m) => (
            <button
              key={m}
              className={`chip chip-tag ${m === activeMeasure ? "chip-status" : ""}`}
              onClick={() => onMeasureChange(m)}
              type="button"
            >
              {copyBlock.measureLabels[m].text}
            </button>
          ))}
        </div>
      )}
      <div className="legend-ramp">
        {entry.rampTokens.map((token, i) => (
          <div key={token} className="legend-stop" data-testid={`legend-swatch-${i}`}>
            <span
              className="legend-swatch"
              style={{ background: `var(${token})` }}
              aria-hidden
            />
            <span className="legend-label mono">
              {formatBinLabel(activeMeasure, i)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
